module.exports = __webpack_public_path__ + "img/pe.23591f9d.svg";